export default __webpack_public_path__ + "static/media/rubik-v12-latin-700.83528def.eot";